module.exports = __webpack_public_path__ + "static/media/mundo_poster.d4fec0a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/projects/mundo_poster.jpg
// module id = 172
// module chunks = 0